import { PropsWithChildren } from 'react';

export const DetailsModalBody = ({ children }: PropsWithChildren) => (
  <div className="flex min-h-0 w-full flex-1 flex-col overflow-hidden">
    {children}
  </div>
);
